(function ($) {
    $.fn.resizeImage = function () {
        //alert($('#layoutResize').get(0))
        var oImage = $(this);
        var layoutResize = $('#layoutResize').get(0)
            ? $('#layoutResize')
            : $(
                  '<div id ="layoutResize" activetag="' +
                      oImage.get(0).tagName.toLowerCase() +
                      '" class="layoutResize" >' +
                      '<div id ="borderResize"activetag="' +
                      oImage.get(0).tagName.toLowerCase() +
                      '" class="borderResize" contenteditable="false">' +
                      //+'<label for="imedit-upload" style="z-index: 999999;position:absolute;left:50%;top:40%;"contenteditable="false">'
                      //+'<input type="file" contenteditable="false" id="imedit-upload" value="Choose a file" accept="image/*" onchange="oImage.imageUpload(this)"style="display:none;">'
                      //+'<i id="imedit-edit"class="imgEditor uk-icon-large uk-icon-cloud-upload"></i></label>'
                      //+'<i class="imgEditor uk-icon-large uk-icon-refresh" style="z-index: 999999;position:absolute;left:50%;top:60%;"contenteditable="false" onclick="oImage.imageReChoose(this)"></i>'
                      //+'<i id="imedit-rechoose"class="imgEditor uk-icon-large uk-icon-wrench" style="z-index: 999999;position:absolute;left:50%;top:50%;"contenteditable="false" onclick="oImage.imageReEdit(this)"></i>'
                      '<div id ="nwResize" class="pointBlock nwResize"></div>' +
                      '<div id ="nResize" class="pointBlock nResize"></div>' +
                      '<div id ="neResize" class="pointBlock neResize"></div>' +
                      '<div id ="wResize" class="pointBlock wResize"></div>' +
                      '<div id ="eResize" class="pointBlock eResize"></div>' +
                      '<div id ="swResize" class="pointBlock swResize"></div>' +
                      '<div id ="sResize" class="pointBlock sResize"></div>' +
                      '<div id ="seResize" class="pointBlock seResize"></div>' +
                      '</div></div>'
              );

        layoutResize.find('.pointBlock').css({ top: 0, left: 0 });
        var borderResize = layoutResize.find('.borderResize');
        layoutResize.width($(this).width()).height($(this).height());
        //alert('w' +oImage.attr('style'))
        //oImage.width($(this).width()).height($(this).height());
        var oImageBorder = 0;
        if ($(this).attr('border') != undefined) {
            oImageBorder = $(this).attr('border') * 2;
        }

        borderResize.css({
            width: $(this).width() + oImageBorder,
            height: $(this).height() + oImageBorder,
            left: 0,
            top: 0,
        });
        layoutResize
            .css({
                width: $(this).width() + oImageBorder,
                height: $(this).height() + oImageBorder,
                left: $(this).position().left,
                top: $(this).position().top,
                margin: $(this).css('margin'),
            })
            .find('.nwResize')
            .css({
                left: '0%',
                top: '0%',
            })
            .end()
            .find('.nResize')
            .css({
                left: '50%',
                top: '0%',
            })
            .end()
            .find('.neResize')
            .css({
                left: '100%',
            })
            .end()
            .find('.wResize')
            .css({
                left: '0',
                top: '50%',
            })
            .end()
            .find('.eResize')
            .css({
                left: '100%',
                top: '50%',
            })
            .end()
            .find('.swResize')
            .css({
                left: '0',
                top: '100%',
            })
            .end()
            .find('.sResize')
            .css({
                left: '50%',
                top: '100%',
            })
            .end()
            .find('.seResize')
            .css({
                left: '100%',
                top: '100%',
            });

        if (oImage.get(0).tagName.toLowerCase() == 'table') {
            $(this).before(layoutResize);
        } else {
            $(this).after(layoutResize);
        }

        layoutResize.find('.pointBlock').each(function () {
            $(this).draggable({
                snap: '*',
                start: function () {
                    rowThis = $(this).clone();
                    layoutResize.append(rowThis);
                    //rowThis.css({'zIndex':'-100000'})
                    startWidth = borderResize.width();
                    startHeight = borderResize.height();
                    $(this).css({ visibility: 'hidden' });
                },
                drag: function (event, ui) {
                    console.log('RVwys.shiftKey->' + RVwys.shiftKey);
                    if (RVwys.shiftKey) {
                        if (!$(this).draggable('option', 'snap')) {
                            console.log(
                                'resize img snap shiftKey ->' +
                                    $(this).draggable('option', 'snap')
                            );
                            $(this).draggable('option', 'snap', '*');
                        }
                    } else {
                        if ($(this).draggable('option', 'snap')) {
                            console.log(
                                'resize img snap->' +
                                    $(this).draggable('option', 'snap')
                            );
                            $(this).draggable('option', 'snap', false);
                        }
                    }
                    var resizeCmd = $(this).outputPointerResize(oImage);
                    var actResize = $(this).get(0).id.replace('Resize', '');
                    var borderWidth = borderResize.width();
                    var borderHeight = borderResize.height();

                    var thisLeft = $(this).position().left;
                    var thisTop = $(this).position().top;
                    //$('#mouseXY').html(actResize + '-' + resizeCmd[actResize])
                    if (resizeCmd[actResize]) {
                        var conNav = resizeCmd[actResize];
                        borderResize.css(conNav.css);
                        if (conNav.axis) {
                            $(this).draggable('option', 'axis', conNav.axis);
                        }
                        //$('#mouseXY').html($(this).css('left')+''+rowThis)
                    } else {
                        switch (actResize) {
                            case 'se':
                            case 'sw':
                                if (actResize == 'sw') {
                                    thisLeft = oImage.width() - thisLeft;
                                }
                                borderResize.css({ width: thisLeft });
                                //$('#mouseXY').html(thisLeft)
                                avgHeight =
                                    (oImage.height() * borderResize.width()) /
                                    oImage.width();
                                borderResize.css({ height: avgHeight });

                                autoLeft =
                                    actResize == 'sw'
                                        ? oImage.width() - borderResize.width()
                                        : 0;
                                borderResize.css({
                                    top: 0,
                                    left: autoLeft,
                                });
                                rowThis.css({
                                    left: $(this).css('left'),
                                    top: $(this).css('top'),
                                });
                                break;
                            case 'ne':
                            case 'nw':
                                thisTop = oImage.height() - thisTop;
                                borderResize.css({ height: thisTop });
                                avgWidth =
                                    (oImage.width() * borderResize.height()) /
                                    oImage.height();
                                borderResize.css({ width: avgWidth });
                                //$('#mouseXY').html(actResize)
                                autoLeft =
                                    actResize == 'nw'
                                        ? oImage.width() - avgWidth
                                        : 0;
                                borderResize.css({
                                    top:
                                        oImage.height() - borderResize.height(),
                                    left: autoLeft,
                                });

                                break;

                            default:
                                break;
                        }
                    }
                },
                stop: function (event, ui) {
                    rowThis.remove();
                    $(this).css({ visibility: 'visible' });
                    //$('mouseXY').html('stop'+borderResize.width())
                    var lineheightNum = parseInt(
                        oImage.css('line-height').replace('px', '')
                    );
                    oImage.css('line-height', lineheightNum.toFixed(3) + 'px');
                    oImage
                        .width(borderResize.width().toFixed(3))
                        .height(borderResize.height().toFixed(3))
                        .each(function () {
                            $(this).resizeImage();
                            parent.$('.imageWidth').val(oImage.width());
                            parent.$('.imageWidthPX dt a span').html('px');
                            parent.$('.imageHeight').val(oImage.height());
                            parent.$('.imageHeightPX dt a span').html('px');

                            //image Editor
                            if (
                                RVwys.imageEditorEventmUp &&
                                typeof RVwys.imageEditorEventmUp === 'function'
                            ) {
                                RVwys.imageEditorEventmUp(oImage);
                            }
                        });
                },
            });
        });
        return $(this);
    };
    $.fn.outputPointerResize = function (oImage) {
        // n = ne nw e w
        // s = se sw e w
        // e = ne se n s
        // w = nw sw n s

        // sw = n s e w nw se
        // nw = n s e w ne sw
        // ne = n s e w nw se
        // se = n s e w sw ne
        var left = $(this).position().left;
        var top = $(this).position().top;
        var layoutResize = $(this).parent();
        var output = {
            n: { css: {} },
            s: { css: {} },
            e: { css: {} },
            w: { css: {} },
        };

        output.w.css.width = oImage.width() - left;
        output.w.css.height = oImage.height();
        output.w.css.left = oImage.width() - output.w.css.width;
        output.w.css.top = 0;
        output.w.axis = 'x';

        output.e.css.width = left;
        output.e.css.height = oImage.height();
        output.e.css.left = 0;
        output.e.css.top = 0;
        output.e.axis = 'x';

        output.n.css.width = oImage.width();
        output.n.css.height = oImage.height() - top;
        output.n.css.left = 0;
        output.n.css.top = oImage.height() - output.n.css.height;
        output.n.axis = 'y';

        output.s.css.width = oImage.width();
        output.s.css.height = top;
        output.s.css.left = 0;
        output.s.css.top = 0;
        output.s.axis = 'y';
        return output;
    };
})(jQuery);
